import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import { tokens } from '@equinor/eds-tokens';

var buttonTypography = tokens.typography.navigation.button,
  _tokens$colors$intera = tokens.colors.interactive,
  disabledTextColor = _tokens$colors$intera.disabled__text.rgba,
  disabledBorderColor = _tokens$colors$intera.disabled__border.rgba,
  disabledColor = _tokens$colors$intera.disabled__fill.rgba,
  medium = tokens.spacings.comfortable.medium,
  _tokens$shape = tokens.shape,
  _tokens$shape$button = _tokens$shape.button,
  buttonHeight = _tokens$shape$button.minHeight,
  buttonBorderRadius = _tokens$shape$button.borderRadius,
  compactButtonHeight = _tokens$shape._modes.compact.button.minHeight,
  outline = tokens.interactions.focused,
  _tokens$clickbounds = tokens.clickbounds,
  clicboundHeight = _tokens$clickbounds.default__base,
  compactClickboundHeight = _tokens$clickbounds.compact__standard;
var button = {
  background: 'transparent',
  height: "var(--eds_button__height, ".concat(buttonHeight, ")"),
  typography: _objectSpread(_objectSpread({}, buttonTypography), {}, {
    textAlign: 'center',
    fontSize: "var(--eds_button__font_size, ".concat(buttonTypography.fontSize, ")")
  }),
  border: {
    type: 'border',
    width: "var(--eds_button__border_width, 1px)",
    color: 'transparent',
    radius: "var(--eds_button__radius, ".concat(buttonBorderRadius, ")"),
    style: 'solid'
  },
  spacings: {
    top: 'var(--eds_button__padding_y, 0)',
    bottom: 'var(--eds_button__padding_y, 0)',
    left: "var(--eds_button__padding_x, ".concat(medium, ")"),
    right: "var(--eds_button__padding_x, ".concat(medium, ")")
  },
  clickbound: {
    height: clicboundHeight,
    width: '100%',
    offset: {
      top: "".concat((parseInt(clicboundHeight) - parseInt(buttonHeight)) / 2 + 1, "px"),
      left: '0'
    }
  },
  entities: {
    icon: {
      height: 'var(--eds_button__icon__size, 24px)',
      width: 'var(--eds_button__icon__size, 24px)'
    }
  },
  states: {
    hover: {
      border: {
        type: 'border',
        width: '1px',
        color: 'transparent',
        radius: "var(--eds_button__radius, ".concat(buttonBorderRadius, ")"),
        style: 'solid'
      }
    },
    focus: {
      outline: {
        type: 'outline',
        offset: '3px',
        style: 'dashed',
        color: outline.color,
        width: outline.width
      }
    },
    disabled: {
      background: disabledColor,
      border: {
        type: 'border',
        width: '1px',
        color: disabledBorderColor,
        style: 'solid'
      },
      typography: _objectSpread(_objectSpread({}, buttonTypography), {}, {
        color: disabledTextColor,
        textAlign: 'center'
      })
    }
  },
  modes: {
    compact: {
      height: "var(--eds_button__height_compact, ".concat(compactButtonHeight, ")"),
      spacings: {
        top: 'var(--eds_button__padding_y_compact, 0)',
        bottom: 'var(--eds_button__padding_y_compact, 0)'
      },
      clickbound: {
        height: compactClickboundHeight,
        width: '100%',
        offset: {
          top: "".concat((parseInt(compactClickboundHeight) - parseInt(compactButtonHeight)) / 2 + 1, "px"),
          left: '0'
        }
      }
    }
  }
};

export { button };
